import React from 'react';
import { FormattedMessage } from 'react-intl-next';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, xcss } from '@atlaskit/primitives';
import StatusInformationIcon from '@atlaskit/icon/core/status-information';
import { LinkButton } from '@atlaskit/button/new';
import { token } from '@atlaskit/tokens';
import { RovoIcon } from '@atlaskit/logo';

import { messages } from '../../messages';

const aiSubFooterWrapperStyle = xcss({
	borderTopColor: 'color.border',
	borderTopStyle: 'solid',
	borderTopWidth: 'border.width',
	paddingTop: 'space.100',
	paddingBottom: 'space.100',
});

const textColorStyle = xcss({
	paddingTop: 'space.025',
	color: 'color.text.subtlest',
	font: token('font.body.small'),
});

export const AiSubFooter = () => (
	<Box xcss={aiSubFooterWrapperStyle}>
		<Inline alignInline="center" alignBlock="center">
			<LinkButton
				appearance="subtle"
				spacing="compact"
				iconBefore={(iconProps) => (
					<StatusInformationIcon
						{...iconProps}
						color={token('color.text.subtlest')}
						spacing="none"
					/>
				)}
				href="https://www.atlassian.com/trust/atlassian-intelligence"
				rel="noopener"
				target="_blank"
				testId="issue-create-side-panel.ai-footer.disclaimer-text"
			>
				<Box xcss={textColorStyle}>
					<FormattedMessage {...messages.sidePanelFooterDisclaimerText} />
				</Box>
			</LinkButton>
			<LinkButton
				appearance="subtle"
				spacing="compact"
				iconAfter={(iconProps) => <RovoIcon {...iconProps} appearance="brand" size="xsmall" />}
				href="https://support.atlassian.com/organization-administration/docs/understand-atlassian-intelligence-features-in-products/"
				rel="noopener"
				target="_blank"
				testId="issue-create-side-panel.ai-footer.powered-by-rovo-text"
			>
				<Box xcss={textColorStyle}>
					<FormattedMessage {...messages.sidePanelFooterRovoText} />
				</Box>
			</LinkButton>
		</Inline>
	</Box>
);
